import { FC } from "react";

export const HomeTopBar: FC = () => {
  return <div />
}